module.exports = __webpack_public_path__ + "img/DE05709.0a3afaf6.png";